import irisApi from '@services/iris-api'

import { CareProvider, GetCareProvidersInput } from '@providers/providers.types'
import { IrisPaginatedResponse } from '@services/iris-api.types'

export const getCareProviders = async ({ domain, headers = {} }: GetCareProvidersInput) => {
  const url = '/v1/care-providers'
  const payload = { params: { domain }, headers }

  const { data } = await irisApi.get<IrisPaginatedResponse<CareProvider>>(url, payload)

  return data
}
